<div class="login-container">
  <img src="assets/images/cc_original@2x.png" alt="Logo" class="logo">
  <!-- <form (ngSubmit)="onLogin()" class="login-form"> -->
  <form class="login-form">
    <!-- <div class="form-group">
      <label for="username">Username</label>
      <input type="text" id="username" [(ngModel)]="username" name="username" class="form-control" required>
    </div>
    <div class="form-group">
      <label for="password">Password</label>
      <input type="password" id="password" [(ngModel)]="password" name="password" class="form-control" required>
    </div>
    @if (errorMessage) {
    <div class="error-message">{{ errorMessage }}</div>
    }
    <button type="submit" class="btn btn-primary w-100">Login</button> -->
    
    <button type="button" class="btn w-100 mt-3" (click)="loginWithSSO()"><svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="60" height="60" viewBox="0 0 48 48">
<path fill="#ff5722" d="M6 6H22V22H6z" transform="rotate(-180 14 14)"></path><path fill="#4caf50" d="M26 6H42V22H26z" transform="rotate(-180 34 14)"></path><path fill="#ffc107" d="M26 26H42V42H26z" transform="rotate(-180 34 34)"></path><path fill="#03a9f4" d="M6 26H22V42H6z" transform="rotate(-180 14 34)"></path>
</svg>
<span class="ms-2 login-ms">Login with Microsoft</span></button>

  </form>
</div>